import { render, staticRenderFns } from "./updatatrader.vue?vue&type=template&id=5a2cccf0&scoped=true&"
import script from "./updatatrader.vue?vue&type=script&lang=js&"
export * from "./updatatrader.vue?vue&type=script&lang=js&"
import style0 from "./updatatrader.vue?vue&type=style&index=0&id=5a2cccf0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a2cccf0",
  null
  
)

export default component.exports